import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgZone, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalService } from '../../../service/global.service';
import { HttpService } from '../../../service/http.service';
import { Subscription } from 'rxjs';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import * as Stomp from 'stompjs';
import { environment } from '../../../../environments/environment';
import { ScrollToBottomDirective } from '../../../directives/scroll-to-bottom.directive';
import { ClickOutsideDirective } from '../../../directives/click-outside.directive';
import { ToastrService } from 'ngx-toastr';
import { MessageFilterPipe } from '../../../pipes/message-filter.pipe';
import { GlobalSearchPipe } from '../../../pipes/gobal-search.pipe';

declare var SockJS: any;
@Component({
  selector: 'app-product-chat-window',
  standalone: true,
  imports: [CommonModule, FormsModule, PickerComponent, ScrollToBottomDirective, ClickOutsideDirective, ReactiveFormsModule, MessageFilterPipe, GlobalSearchPipe],
  templateUrl: './product-chat-window.component.html',
  styleUrl: './product-chat-window.component.scss'
})
export class ProductChatWindowComponent {

  @Output() openViewDetails = new EventEmitter<boolean>();

  expandChatFlag: boolean = false;
  expandSavedFileFlag: boolean = false;
  filesAttachmentFlag: boolean = false;
  searchMessageFlag: boolean = false;

  personalNoteFlag: boolean = false;
  fileTypeFilter: string = "all";

  isFiles = false;

  isAllFilesLinks = false;

  isLinks = false;
  isEmojiPickerVisible: boolean = false;

  messageList: Array<any> = [];
  savedFileList: Array<any> = [];
  checkBox: boolean = false;
  isAttachmentBox: boolean = false;
  fileAttachmentForm: FormGroup;
  msgSearchText: string = '';

  selectedUser: any = null;
  commonListnerSubscription: Subscription;

  chatMsg: string = '';
  advisorProductId: number = 0;
  stompClient: Stomp.Client;
  stompSubscriber: Stomp.Subscription;
  orderId: any = '';
  imageLoader: boolean = false;

  private timeoutRef: any;
  constructor(public gS: GlobalService,
    private http: HttpService,
    private zone: NgZone,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {
    this.commonListnerSubscription = gS.commonListnerRefresh.subscribe((res: any) => {
      if (res?.type == 'selectUser') {
        if (res?.data) {
          this.selectedUser = res?.data;
          console.log(this.selectedUser, 'Payload');
          if (this.selectedUser) {
            this.advisorProductId = this.selectedUser?.advisorProductOrder
              ?.id;
            if (this.advisorProductId) {
              this.getChatMsgs(this.advisorProductId);
              this.markasRead(this.advisorProductId);
            }
            this.orderId = this.selectedUser?.advisorProductOrder?.orderId;
            if (this.orderId) {
              this.zone.run(async () => {
                if (this.stompSubscriber) {
                  await this.disConnect();
                }
                this.connectSocket();
              })

            }
          }
        }
      }
    });

    this.fileAttachmentForm = formBuilder.group({
      fileUrl: [null, Validators.required],
      extension: [''],
      fileName: ['']
    })
  }

  ngOnInit() {
    this.getSavedAttachmentList();
  }

  ngOnDestroy() {
    this.commonListnerSubscription.unsubscribe();
    this.disConnect();

    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
  }

  getChatMsgs(orderId: any) {
    let payload = {
      customerId: this.gS.userData?.id,
      advisorProductId: orderId,
    }
    this.http.getProductOrderChatMsg(payload).subscribe((data: any) => {
      let value: any = data;
      if (data?.status == 'success') {
        this.messageList = data?.data;
        console.log(this.messageList, 'messageList');

      }
    }, (error) => {
      console.log("error");

    })
  }

  markasRead(orderId: any) {
    let Payload = {
      orderId: orderId,
    }
    this.http.markProductOrderChatMsgRead(Payload).subscribe((res: any) => {
      if (res?.status == 'success') {
        this.gS.triggerCommonListner({
          type: 'UNREAD_COUNT_CHANGE',
          data:this.selectedUser
        })
      }
    })
  }

  getSavedAttachmentList() {
    let payload = {
      userId: this.gS.userData?.id
    }
    this.http.getSavedAttachmentList(payload).subscribe((data: any) => {
      let value: any = data;

      if (data?.status == 'success') {
        this.savedFileList = value?.data;
        console.log(this.savedFileList, 'savedFileList');
      }
    }, (error) => {
      console.log("error");
    })

  }

  expandChatbox() {
    this.expandChatFlag = !this.expandChatFlag;
  }

  clickLink(url: any) {
    if (url) {
      return url && !url.startsWith('http') ? 'https://' + url : url;
    } else {
      return 'https://www.google.com/';
    }
  }

  openFileLink(url: any) {
    if (url) {
      let anchortag = document.createElement('a') as HTMLAnchorElement;

      if (anchortag) {
        anchortag.href = url;
        anchortag.target = '_blank';
        anchortag.click();
      }
    }
  }

  nameWithoutExtension: string = '';

  openAttachmentPicker() {
    const fileInput = document.createElement('input') as HTMLInputElement;
    fileInput.type = 'file';
    fileInput.accept = '*/*';

    fileInput.addEventListener('change', (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.nameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.'));

        this.imageLoader = true;
        const formData = new FormData();
        formData.append('image', file);
        formData.append("extension", file.name.split('.').pop());
        this.http.imageUpload(formData).subscribe((res: any) => {
          if (res?.status == 'success') {
            this.fileAttachmentForm.patchValue({
              fileUrl: res?.data?.file_url,
              extension: res?.data?.extension,
              fileName: this.nameWithoutExtension ? this.nameWithoutExtension : ''
            });

            this.imageLoader = false;
          } else {
            this.imageLoader = false;
          }
        });
      }
    });

    fileInput.click();
  }

  selectFromSavedFile() {
    this.isAttachmentBox = false;
    this.checkBox = false;
    this.expandSavedFileFlag = true;
  }

  sendMessage(msg: any, type: string) {
    this.isEmojiPickerVisible=false;
    let socketPayload: any = {
      advisorProductOrderId: this.advisorProductId,
      sentFrom: this.gS.userData?.id,
      isConsultant: false,
      message: msg,
      messageType: type,
      senderName: this.gS.userData?.name,
      createdAt: Date.now()
    }

    if (type == 'FILE') {
      socketPayload.fileName = this.fileAttachmentForm.value?.fileName;
      socketPayload.fileExtension = this.fileAttachmentForm.value?.extension;
    }

    this.sendSocket(socketPayload);
    this.chatMsg = '';

    let payload: any = {
      advisorProductOrderId: this.advisorProductId,
      sentFrom: this.gS.userData?.id,
      isConsultant: false,
      message: msg,
      messageType: type
    }

    if (type == 'FILE') {
      payload.fileName = this.fileAttachmentForm.value?.fileName;
      payload.fileExtension = this.fileAttachmentForm.value?.extension;
      if (this.checkBox) {
        payload.isSavedForFuture = this.checkBox;
      }
    }

    this.fileAttachmentForm.reset();
    this.checkBox = false;

    this.http.sendProductOrderChatMsg(payload).subscribe((data: any) => {
      let value: any = data;
      if (data?.status == 'success') {
        // console.log(value, 'chatMsgs');
        if (type == 'FILE') {
          this.getSavedAttachmentList();
        }
      }
    }, (error) => {
      console.log("error");

    })
  }

  sendFile() {
    this.sendMessage(this.fileAttachmentForm.value?.fileUrl, 'FILE');
    this.attachmentOuside();
  }

  sendSavedFile(item: any) {
    console.log(item, 'savedFileList');
    this.checkBox = false;
    this.fileAttachmentForm.patchValue({
      fileUrl: item?.fileUrl,
      fileName: item?.fileName,
      extension: item?.fileExtension
    })
    this.sendMessage(this.fileAttachmentForm.value?.fileUrl, 'FILE');
    this.resetFlag();
    this.expandChatFlag = false;
  }

  searchMessageAction() {
    this.personalNoteFlag = false;
    this.searchMessageFlag = true;
    this.filesAttachmentFlag = false;
  }

  fileAttachment() {
    this.personalNoteFlag = false;
    this.searchMessageFlag = false;
    this.filesAttachmentFlag = true;
  }

  showSavedFile() {
    this.filesAttachmentFlag = false;
    this.searchMessageFlag = false;
    this.expandSavedFileFlag = true;
  }

  resetFlag() {
    this.personalNoteFlag = false;
    this.searchMessageFlag = false;
    this.filesAttachmentFlag = false;
    this.expandSavedFileFlag = false;
    this.msgSearchText = '';
  }

  clearSearch() {
    this.msgSearchText = '';
  }

  viewFiles(filetype: any) {
    this.fileTypeFilter = filetype;
  }

  addEmoji(event: any) {
    if(event?.emoji?.native){
      this.chatMsg += event?.emoji?.native;
    }
  }

  connectSocket() {
    const socket = new SockJS(environment.apiEndPoint + 'testchat');
    this.stompClient = Stomp.over(socket);

    // this.stompClient.debug = function (){};
    this.stompClient.connect({}, (frame: any) => {
      const destination: string = `/topic/prodcutOrderChat/${this.orderId}/initial`;
      this.socketCallback(destination);
    });
  }

  socketCallback(destination: string) {
    this.stompSubscriber = this.stompClient.subscribe(destination, (message: Stomp.Message) => {
      let socketMessage = JSON.parse(message.body);
      console.log(socketMessage, 'socket');
      if (socketMessage) {
        this.messageList = [...this.messageList, socketMessage];
        this.timeoutRef=setTimeout(() => {
          this.markasRead(this.advisorProductId);
        }, 3000);
      }
    });
  }

  sendSocket(socketPayload: any) {
    this.stompClient.send(`/topic/prodcutOrderChat/${this.orderId}/initial`, {},
      JSON.stringify(socketPayload));
  }

  disConnect() {
    return new Promise((resolve, reject) => {
      this.stompSubscriber.unsubscribe();
      this.stompClient.disconnect(() => {
        console.log("Disconnnected");
        resolve(true);
      });
    })

  }

  openAttachment(event: Event) {
    this.isAttachmentBox = !this.isAttachmentBox;
    this.expandSavedFileFlag = false;
    event.stopImmediatePropagation();
  }

  updateFileNameValidation(event: Event) {
    const fileNameControl = this.fileAttachmentForm.get('fileName');
    if (this.checkBox) {
      fileNameControl?.setValidators([Validators.required]);
    } else {
      fileNameControl?.clearValidators();
    }
    this.fileAttachmentForm.patchValue({
      fileName: this.nameWithoutExtension ? this.nameWithoutExtension : ''
    });
    fileNameControl?.updateValueAndValidity();


  }

  attachmentOuside() {
    this.isAttachmentBox = false;
    this.checkBox = false;
  }

  removeFileAttachment(event: Event) {
    event.stopImmediatePropagation();
    this.fileAttachmentForm.reset();
    this.checkBox = false;
  }

  keyDownEvent(event: any) {

    if (event.keyCode == '13') {
      event.preventDefault();
      if (this.chatMsg) {
        this.sendMessage(this.chatMsg, 'TEXT');
      }
    }
  }

  viewDetails() {
    this.openViewDetails.emit(true);
  }
}
